import { PaymentMethod } from '@stripe/stripe-js'
import { EUROPE_ECONOMIC_AREA, STRIPE_PAYMENT_FEES } from './processor-fees'

type StripeMerchantAccount = {
  merchantAccountExists?: boolean | null
  chargesEnabled?: boolean | null
  required?: string[] | null
}

export const getStripeConnectStatus = (
  merchantAccount?: StripeMerchantAccount | null
) => {
  const required = merchantAccount?.required ?? []
  const isMerchant = !!merchantAccount?.merchantAccountExists
  const chargesEnabled = !!merchantAccount?.chargesEnabled
  const onboardingComplete = isMerchant && required.length < 1

  return {
    isMerchant,
    chargesEnabled,
    onboardingComplete,
    required,
    isReady: isMerchant && chargesEnabled && onboardingComplete,
  }
}

export const getBankingCountryByPaymentMethod = (
  paymentMethod: PaymentMethod
) => {
  if (!paymentMethod) return undefined
  const { type, card } = paymentMethod
  return card?.country ?? undefined
}

export const getProcessorFees = (regionCode?: string) => {
  if (!regionCode) return STRIPE_PAYMENT_FEES.INTERNATIONAL
  if (regionCode === 'GB') return STRIPE_PAYMENT_FEES.GBP
  if (EUROPE_ECONOMIC_AREA.includes(regionCode)) return STRIPE_PAYMENT_FEES.EEA
  return STRIPE_PAYMENT_FEES.INTERNATIONAL
}

export const getDonationTotal = ({
  amount,
  platformFee,
  regionCode,
  coverPlatformFee,
}: {
  amount: number
  platformFee: number
  regionCode?: string
  coverPlatformFee?: boolean
}) => {
  let donationAmountCents = amount

  let totalDonationCents = amount

  const platformFeeAmountCents = Math.ceil(
    donationAmountCents * (platformFee / 100)
  )

  if (coverPlatformFee) {
    totalDonationCents = donationAmountCents + platformFeeAmountCents
  }

  donationAmountCents = totalDonationCents - platformFeeAmountCents

  return {
    donation: donationAmountCents, // Amount going to charity (in cents)
    platformFee: platformFeeAmountCents, // Platform fee (in cents)
    total: totalDonationCents, // Total donation amount (in cents)
    regionCode,
  }
}
